import React, {useEffect, useState} from 'react'
import ReactQuill from 'react-quill'
import 'react-quill/dist/quill.snow.css'
import {Form, Input, Button, Row, Col, Select} from 'antd'
import apiRequest from '../../hooks/ApiRequest'
import {toast} from 'react-toastify'

const AssigneEmailTemplate = ({
  visible,
  onClose,
  templateId,
  onSuccess,
  form,
}) => {
  const {getFieldDecorator, setFieldsValue, validateFields, resetFields} = form
  const {Option} = Select
  const [templateList, setTemplateList] = useState([])
  const [moduleList, setModuleList] = useState([])
  const [permissionList, setPermissionList] = useState([])
  const loggedInUserID = JSON.parse(localStorage.getItem('loggedInUserID'))
  const user = JSON.parse(localStorage.getItem('user'))

  const fetchData = async () => {
    const templateData = await apiRequest(
      process.env.REACT_APP_BASE_URL_EMAIL + '/Email/get-template',
      'GET',
    )
    const moduleData = await apiRequest(
      `${process.env.REACT_APP_BASE_URL_AUTH}/api/RoleClaimManager/modules`,
      'GET',
    )
    setTemplateList(templateData?.data)
    setModuleList(moduleData?.data)
  }

  const fetchPermissionsByModule = async moduleId => {
    try {
      const permissionData = await apiRequest(
        `${process.env.REACT_APP_BASE_URL_AUTH}/api/RoleClaimManager/modules/${moduleId}/permissions`,
        'GET',
      )
      console.log('permissionData', permissionData?.data)

      setPermissionList(permissionData?.data[0]?.permissions)
    } catch (error) {
      console.error('Error fetching permissions:', error)
    }
  }

  useEffect(() => {
    if (templateId) {
      fetchTemplateDetails(templateId)
    } else {
      resetFields()
    }
    fetchData()
  }, [templateId, visible])

  const fetchTemplateDetails = async id => {
    try {
      const response = await apiRequest(
        process.env.REACT_APP_BASE_URL_EMAIL + `/RegisterEmail/GetById/${id}`,
        'GET',
      )
      if (response.success) {
        setFieldsValue({
          templateId: response?.data?.templateId,
          moduleId: response?.data?.moduleId,
          permissionId: response?.data?.permissionId,
        })
        fetchPermissionsByModule(response?.data?.moduleId)
      }
    } catch (error) {
      console.error('Error fetching template:', error)
    }
  }

  const extractVariables = body => {
    const regex = /\{{(.*?)\}}/g
    let matches = []
    let match
    while ((match = regex.exec(body)) !== null) {
      matches.push(match[1])
    }
    return matches
  }

  const handleSubmit = (e) => {
    e.preventDefault();
    validateFields(async (err, values) => {
      if (err) return;
  
      const variables = extractVariables(values.body);
  
      // Include 'id' only if updating (templateId exists)
      const payload = {
        ...(templateId && { id: templateId }),
        templateId: values.templateId,
        moduleId: values.moduleId,
        permissionId: values.permissionId,
        attachmentFileName: ['string'],
        actionType: 'string',
        insurerId: loggedInUserID,
      };
  
      const url = templateId
        ? `${process.env.REACT_APP_BASE_URL_EMAIL}/RegisterEmail/Update`
        : `${process.env.REACT_APP_BASE_URL_EMAIL}/RegisterEmail/Add`;
      
      const method = 'POST';
  
      try {
        const response = await apiRequest(url, method, payload);
        if (response?.success) {
          toast.success(
            templateId
              ? 'Template updated successfully'
              : 'Template added successfully'
          );
          onSuccess && onSuccess();
        } else {
          toast.error(response?.error || 'Error saving template');
        }
      } catch (error) {
        toast.error('Something went wrong. Please try again.');
      }
    });
  };
  

  return (
    <div className="container mt-3">
      <div className="card p-4">
        <Form
          layout="vertical"
          style={{height: '250px'}}
          onSubmit={handleSubmit}>
          <Row gutter={16}>
            <Col md={12}>
              <Form.Item label="Select Template">
                {getFieldDecorator('templateId', {
                  rules: [
                    {required: true, message: 'Please select a template'},
                  ],
                })(
                  <Select placeholder="Select Template">
                    {templateList?.map(template => (
                      <Option key={template?.id} value={template?.id}>
                        {template?.name}
                      </Option>
                    ))}
                  </Select>,
                )}
              </Form.Item>
            </Col>
            <Col md={12}>
              <Form.Item label="Select Module">
                {getFieldDecorator('moduleId', {
                  rules: [{required: true, message: 'Please select a module'}],
                })(
                  <Select
                    placeholder="Select Module"
                    onChange={fetchPermissionsByModule}>
                    {moduleList?.map(module => (
                      <Option key={module?.moduleId} value={module?.moduleId}>
                        {module?.moduleName}
                      </Option>
                    ))}
                  </Select>,
                )}
              </Form.Item>
            </Col>
            <Col md={12}>
              <Form.Item label="Select Permission">
                {getFieldDecorator('permissionId', {
                  rules: [
                    {required: true, message: 'Please select a permission'},
                  ],
                })(
                  <Select placeholder="Select Permission">
                    {permissionList?.map(permission => (
                      <Option
                        key={permission?.permissionId}
                        value={permission?.permissionId}>
                        {permission?.permissionName}
                      </Option>
                    ))}
                  </Select>,
                )}
              </Form.Item>
            </Col>
          </Row>
          <Form.Item>
            <Button type="primary" htmlType="submit" className="btn-success">
              {templateId ? 'Update Template' : 'Save Template'}
            </Button>
          </Form.Item>
        </Form>
      </div>
    </div>
  )
}

export default Form.create()(AssigneEmailTemplate)
